module.exports = __webpack_public_path__ + "static/media/mini-go-drive.c6e4b920.png";